import React, { useEffect, useState } from "react";
import { Search } from "lucide-react";
import "./style.css";

const NoRequests = props => {
    const rows = new Array(21).fill(undefined);
    const cols = new Array(20).fill(undefined);
    const gradientOverlay = new Array(5).fill(undefined);
    const size = 315;
    return (
        <div
            style={{
                position: "relative",
                height: `${size}px`,
                width: `${size}px`,
                overflow: "hidden",
                borderRadius: "50%",
            }}
        >
            <div
                style={{
                    borderRadius: "50%",
                    backgroundColor: "var(--accent-6)",
                    color: "var(--accent-11)",
                    position: "absolute",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    top: "50%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "40px",
                    height: "40px",
                    zIndex: "3",
                }}
            >
                <Search />
            </div>
            <div
                style={{
                    borderRadius: "50%",
                    position: "absolute",
                    display: "flex",
                    flexWrap: "wrap",
                    whiteSpace: "nowrap",
                    alignItems: "center",
                    justifyContent: "center",
                    bottom: "20%",
                    left: "50%",
                    transform: "translate(-50%, -50%)",
                    width: "40px",
                    height: "40px",
                    zIndex: "3",
                }}
            >
                <p className="m-text is-size-xl" style={{ fontWeight: 500 }}>
                    No Approval Requests Yet
                </p>
                <p className="m-text is-size-l" style={{ paddingTop: 2 }}>
                    You'll See Approval Requests Here.
                </p>
            </div>
            <div
                style={{
                    position: "relative",
                }}
            >
                {rows.map((row, index) => {
                    return (
                        <div
                            key={index}
                            className="no-reqs-bkg"
                            style={{
                                width: `${size}px`,
                                height: `${size / 20}px`,
                                display: "flex",
                                flexDirection: "row",
                                justifyContent: "space-between",
                            }}
                        >
                            {cols.map((col, index) => {
                                return (
                                    <div
                                        key={index}
                                        style={{
                                            width: "2px",
                                            height: "2px",
                                            backgroundColor: "var(--core-green-12)",
                                            borderRadius: "50%",
                                        }}
                                    />
                                );
                            })}
                        </div>
                    );
                })}
                {gradientOverlay.map((g, index) => {
                    return (
                        <div
                            key={index}
                            style={{
                                position: "absolute",
                                top: "0",
                                height: `${size}px`,
                                width: `${size}px`,
                                background:
                                    "radial-gradient(circle, rgba(0,0,0,0) 25%, var(--neutral-3) 100%)",
                                mixBlendMode: "darken",
                            }}
                        />
                    );
                })}
            </div>
        </div>
    );
};
export default NoRequests;
